import { render, staticRenderFns } from "./fileTreeDetail.vue?vue&type=template&id=4c9391c3&scoped=true&"
import script from "./fileTreeDetail.vue?vue&type=script&lang=js&"
export * from "./fileTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9391c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9391c3')) {
      api.createRecord('4c9391c3', component.options)
    } else {
      api.reload('4c9391c3', component.options)
    }
    module.hot.accept("./fileTreeDetail.vue?vue&type=template&id=4c9391c3&scoped=true&", function () {
      api.rerender('4c9391c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonFile/detail/fileTreeDetail.vue"
export default component.exports